import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import '../../atoms/buttons/enums.js';
import { isSafari } from '../../utilities/dom-helpers/index.js';

const AccordionElementBase = (superClass) => {
    class AccordionElement extends superClass {
        constructor() {
            super(...arguments);
            this.title = '';
            this.subtitle = '';
            this.image = '';
            this.imageAlt = '';
            this.index = '';
            this.elementDetails = '';
            this.isGroupsite = false;
            this.titleColor = '';
            this.dividerColor = '';
            this.arrowIcon = '';
        }
        collapseInactiveItem() {
            const header = this.shadowRoot && this.shadowRoot.querySelector('.header');
            if (header &&
                header.getAttribute('active') === null &&
                header.nextElementSibling)
                header.nextElementSibling.style.maxHeight = '';
        }
        expandActiveItem() {
            const activeHeader = this.shadowRoot && this.shadowRoot.querySelector('.header[active]');
            if (activeHeader && activeHeader.nextElementSibling) {
                activeHeader.nextElementSibling.style.maxHeight = `${activeHeader.nextElementSibling.scrollHeight}px`;
            }
        }
        handleClick(e) {
            const ariaAttr = 'aria-expanded';
            const { accHeader, accContent, inner } = this.getEventTargetElements(e);
            const stickyHeaderHeight = this.getStickyHeaderHeight();
            const { previousContentHeight, previousActiveHeader } = this.collapseOtherAccordions(accHeader, ariaAttr);
            if (accHeader.hasAttribute('active')) {
                accHeader.removeAttribute('active');
                accHeader.setAttribute(ariaAttr, 'false');
                accContent.style.maxHeight = null;
            }
            else {
                accHeader.setAttribute('active', '');
                accHeader.setAttribute(ariaAttr, 'true');
                const accordionContent = accContent.querySelector('slot[name="accordion-content"]') ||
                    accContent.querySelector('slot[name="image-accordion-content"]');
                if (accordionContent === null || accordionContent === void 0 ? void 0 : accordionContent.assignedElements()) {
                    accContent.style.maxHeight = `${inner.offsetHeight}px`;
                }
            }
            this.adjustScrollPosition(previousContentHeight, previousActiveHeader, accHeader, stickyHeaderHeight);
            if (this.onToggle)
                this.onToggle(accContent);
        }
        getEventTargetElements(e) {
            var _a;
            const accHeader = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest('.header');
            const accContent = accHeader === null || accHeader === void 0 ? void 0 : accHeader.nextElementSibling;
            const inner = accContent === null || accContent === void 0 ? void 0 : accContent.querySelector('.inner');
            return { accHeader, accContent, inner };
        }
        getStickyHeaderHeight() {
            const stickyHeader = document.querySelector('.top');
            return stickyHeader ? stickyHeader.offsetHeight || 0 : 0;
        }
        collapseOtherAccordions(currentHeader, ariaAttr) {
            let previousContentHeight = 0;
            let previousActiveHeader = null;
            this.parentNode.querySelectorAll('accordion-item').forEach((el) => {
                const content = el.shadowRoot.querySelector('.content');
                const accItem = el.shadowRoot.querySelector('.header');
                if (accItem !== currentHeader) {
                    if (accItem.hasAttribute('active')) {
                        previousActiveHeader = accItem;
                        const previousContent = previousActiveHeader === null || previousActiveHeader === void 0 ? void 0 : previousActiveHeader.nextElementSibling;
                        previousContentHeight = previousContent.offsetHeight;
                    }
                    accItem.removeAttribute('active');
                    accItem.setAttribute(ariaAttr, 'false');
                    content.style.maxHeight = '';
                }
            });
            return { previousContentHeight, previousActiveHeader };
        }
        adjustHeaderPosition(target) {
            const getStickyHeight = () => {
                const sticky = document.querySelector('.top');
                return sticky ? sticky.getBoundingClientRect().height : 0;
            };
            requestAnimationFrame(() => {
                const stickyHeight = getStickyHeight();
                const rect = target.getBoundingClientRect();
                const desiredTop = window.scrollY + rect.top - stickyHeight;
                window.scrollTo({
                    top: Math.max(0, desiredTop),
                    behavior: 'smooth',
                });
                if (isSafari) {
                    setTimeout(() => {
                        window.scrollTo({
                            top: Math.max(0, desiredTop),
                            behavior: 'smooth',
                        });
                    }, 300);
                }
            });
        }
        adjustScrollPosition(previousContentHeight, previousActiveHeader, accHeader, stickyHeaderHeight) {
            const headerRect = accHeader.getBoundingClientRect();
            const shouldCompensateCollapse = previousContentHeight > 0 &&
                previousActiveHeader &&
                previousActiveHeader.getBoundingClientRect().top < headerRect.top;
            if (shouldCompensateCollapse) {
                requestAnimationFrame(() => {
                    const offsetScrollY = -previousContentHeight + headerRect.top - stickyHeaderHeight;
                    window.scrollBy({
                        top: offsetScrollY,
                        behavior: 'instant',
                    });
                });
            }
            else {
                this.adjustHeaderPosition(accHeader);
            }
        }
        firstUpdated() {
            this.expandActiveItem();
        }
        updated() {
            if (this.isExpanded)
                this.expandActiveItem();
            this.collapseInactiveItem();
        }
        // eslint-disable-next-line class-methods-use-this
        renderAccordionElement(content) {
            return $ `${content}`;
        }
    }
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "title", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "subtitle", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "image", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "imageAlt", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "index", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "elementDetails", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "isDisabled", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "isExpanded", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "highlightActiveItem", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "smallTitles", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "rtl", void 0);
    __decorate([
        e({ type: Boolean })
    ], AccordionElement.prototype, "isGroupsite", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "titleColor", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "dividerColor", void 0);
    __decorate([
        e({ type: String })
    ], AccordionElement.prototype, "arrowIcon", void 0);
    __decorate([
        e({ type: Function })
    ], AccordionElement.prototype, "onToggle", void 0);
    return AccordionElement;
};

export { AccordionElementBase };
